import { createFileRoute } from '@tanstack/react-router'
import { LegalEntityForm, organizationSearchSchema } from '@/features/master-data/index.ts'

export const Route = createFileRoute('/_authenticated/master-data/legal-entities/new')({
  component: NewLegalEntityPage,
  head: () => ({ meta: [{ title: '新建经营主体 · Super Mega' }] }),
  validateSearch: organizationSearchSchema
})

function NewLegalEntityPage() {
  return <LegalEntityForm returnSearch={Route.useSearch()} />
}
